import BroadcastCampaignsAPI from 'dashboard/api/broadcastCampaigns';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getBroadcastCampaigns(_state) {
    return _state.records;
  },

  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit('setFetching', true);

    try {
      const response = await BroadcastCampaignsAPI.get();
      commit('setCampaigns', response.data);
    } finally {
      commit('setFetching', false);
    }
  },

  async create({ dispatch, commit }, payload) {
    commit('setCreating', true);

    try {
      await BroadcastCampaignsAPI.create(payload);
      dispatch('get');
    } finally {
      commit('setCreating', false);
    }
  },

  async update({ dispatch, commit }, { id, data }) {
    commit('setUpdating', true);

    try {
      await BroadcastCampaignsAPI.update(id, data);
      dispatch('get');
    } finally {
      commit('setUpdating', false);
    }
  },

  async delete({ dispatch, commit }, id) {
    commit('setDeleting', true);

    try {
      await BroadcastCampaignsAPI.delete(id);
      dispatch('get');
    } finally {
      commit('setDeleting', false);
    }
  },
};

export const mutations = {
  setCampaigns(_state, campaigns) {
    _state.records = campaigns;
  },

  setFetching(_state, value) {
    _state.uiFlags.isFetching = value;
  },

  setCreating(_state, value) {
    _state.uiFlags.isCreating = value;
  },

  setUpdating(_state, value) {
    _state.uiFlags.isUpdating = value;
  },

  setDeleting(_state, value) {
    _state.uiFlags.isDeleting = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
